import React from 'react';
import Layout from '../../../layout/Layout';
import HeaderPageSection from '../../molecules/HeaderPageSection/HeaderPageSection';
import Breadcrumb from '../../atoms/Breadcrumb/Breadcrumb';
import arrowIcon from '../../../assets/arrowNext.png';
import CreateRuleForm from '../organisms/CreateRuleForm';

export default function CreateRule() {
    return (
        <Layout>
            <HeaderPageSection />
          <Breadcrumb
            title={'Crear nueva regla'}
            separator={<img src={arrowIcon} alt="arrowIcon" />}
            items={[{ label: 'Reglas', path: '/rules' }, { label: 'Crear Regla', path: '#' }]} />
          <div className="m-auto mt-6">
            <CreateRuleForm />
            </div>
        </Layout>

    )
}

